// FIXME: This component is deprecated. Kill it A.S.A.P.!

/* eslint-disable @typescript-eslint/no-var-requires */
var flags = require('./flags/flags.svg');
var icons = require('./icons/icons.svg');
var MFLogoPhone = require('./images/logo-phone.svg');
var SpinnerImg = require('./images/spinner.svg');
const getAssetResource = asset => asset.default || asset;
window._ASSETS = {
  flags: getAssetResource(flags),
  icons: getAssetResource(icons),
  MFLogoPhone: getAssetResource(MFLogoPhone),
  SpinnerImg: getAssetResource(SpinnerImg)
};